<div class="container-fluid background">
  <div class="row main">
    <app-banner *ngIf="banner" [banner]="banner" [showLogo]="showLogo"></app-banner>
    <ng-content></ng-content>
  </div>
</div>
